import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { menuService } from 'services';

const initialState = {
  data: [],
  statusDataTree: '',
  sideNavbar: {
    isShowed: true,
    width: 250,
    display: 'none'
  }
};

export const getMenuTree = createAsyncThunk(
  'menu/fetchAllData',
  async () => {
    const response = await menuService.tree();
    return response;
  }
);

export const menuSlice = createSlice({
  name: 'menu',
  initialState: initialState,
  reducers: {
    setSideNavbar: (state, action) => {
      state['sideNavbar'] = action.payload;
    },
    resetData: (state, action) => {
      const payload = action.payload;
      if(typeof payload === 'string'){
        state[payload] = initialState[payload];
      }else if(Array.isArray(payload)){
        payload.forEach(item => 
          state[item] = initialState[item]
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMenuTree.pending, (state) => {
        state.statusDataTree = 'loading';
      })
      .addCase(getMenuTree.fulfilled, (state, action) => {
        state.statusDataTree = 'success';
        state.data = action.payload;
      })
      .addCase(getMenuTree.rejected, (state) => {
        state.statusDataTree = 'error';
      });
  }
});

export const { setSideNavbar, setFilter, resetData } = menuSlice.actions;

const menuReducer = menuSlice.reducer;
export default menuReducer;